import { useLayoutEffect, useMemo } from 'react'
import { useQueryClient } from '@tanstack/react-query'

import { WebsiteRead } from '@/api/dashboard'
import { useTransformedTheme } from './useTransformedTheme'
import { themeQueryOpts } from '../api'
import { groupTheme } from '../libs/theme'

export const useGroupedTheme = (gameId: string, website: WebsiteRead) => {
  const ql = useQueryClient()
  const theme = ql.getQueryData(themeQueryOpts(gameId, website).queryKey)
  const { data, loading, transform } = useTransformedTheme(gameId, website)

  useLayoutEffect(() => {
    console.log('[useGroupedTheme] transform for', theme?.name)
    transform()
  }, [transform, theme])

  const result = useMemo(() => {
    return data ? groupTheme(data.json) : null
  }, [data])

  return { data: result, loading }
}
